import { FileText, Calendar, User, Monitor, ExternalLink } from "lucide-react";

export default function LicenseContractSection() {
  const terms = [
    { icon: Calendar, label: "Anual", description: "Validade de 12 meses" },
    { icon: User, label: "Individual", description: "Uma licença por empresa" },
    { icon: Monitor, label: "Intransferível", description: "Vinculada ao dispositivo" },
    { icon: FileText, label: "Vinculada ao CNPJ", description: "Registrada no CNPJ" },
  ];

  return (
    <section
      id="license-contract"
      className="relative py-16 md:py-32 bg-[#1C1F26]"
      data-testid="license-contract-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            Legal
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB]">
            Contrato de <span className="text-[#F59E0B]">Licença</span>
          </h2>
        </div>

        {/* License Summary */}
        <div className="max-w-3xl mx-auto">
          <div className="bg-[#0F1115] border border-[#2A2F38] rounded-sm p-8 md:p-10">
            <h3 className="font-heading text-xl font-bold text-[#E5E7EB] mb-6 text-center">
              Resumo da Licença Anual
            </h3>

            {/* Terms Grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
              {terms.map((term, index) => (
                <div
                  key={index}
                  className="text-center p-4 bg-[#1C1F26] rounded-sm border border-[#2A2F38]"
                  data-testid={`license-term-${index}`}
                >
                  <term.icon className="h-6 w-6 text-[#F59E0B] mx-auto mb-2" />
                  <p className="text-sm font-bold text-[#E5E7EB]">{term.label}</p>
                  <p className="text-xs text-[#6B7280] mt-1">{term.description}</p>
                </div>
              ))}
            </div>

            {/* Legal Text */}
            <div className="border-t border-[#2A2F38] pt-6">
              <p className="text-sm text-[#9CA3AF] mb-4">
                A licença do KpAction é regida pelos seguintes termos:
              </p>
              <ul className="space-y-2 text-sm text-[#6B7280]">
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B]">•</span>
                  Uso exclusivo pela empresa titular do CNPJ cadastrado
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B]">•</span>
                  Vinculação ao dispositivo registrado no momento da ativação
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B]">•</span>
                  Proibida redistribuição, sublicenciamento ou engenharia reversa
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B]">•</span>
                  Uso indevido implica cancelamento imediato da licença
                </li>
              </ul>
            </div>

            {/* Natureza da Licença */}
            <div className="mt-8 pt-6 border-t border-[#2A2F38]">
              <h4 className="font-heading text-lg font-bold text-[#E5E7EB] mb-4">
                Natureza da Licença
              </h4>
              <div className="space-y-3 text-sm text-[#9CA3AF]">
                <p>
                  A aquisição do KpAction concede ao cliente uma licença de uso limitada, não exclusiva e intransferível do software.
                </p>
                <p>
                  A licença permite utilização apenas pela empresa titular do CNPJ informado no momento da ativação.
                </p>
                <p>
                  A licença é vinculada ao dispositivo utilizado no momento da ativação e não pode ser transferida para terceiros sem autorização expressa da EVIDENTIA TECNOLOGIA LTDA.
                </p>
              </div>
            </div>

            {/* Link to Full Terms */}
            <div className="mt-8 text-center">
              <a
                href="/termos-de-licenca"
                className="inline-flex items-center gap-2 text-[#F59E0B] hover:text-[#FBBF24] transition-colors text-sm"
                data-testid="license-terms-link"
              >
                <FileText className="h-4 w-4" />
                Ver Termos Completos de Licença
                <ExternalLink className="h-3 w-3" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
